import React from 'react'
import { Box, Typography } from '@material-ui/core'
import strings from 'strings'

const UDHeader = ({ dateStr, timeStr, firstName, pending, stats, range, setRange, classes }) => {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={3}>
            <Box>
                <Typography className={classes.dateLabel}>{strings.UD.DATE_LABEL.replace('{date}', dateStr).replace('{time}', timeStr)}</Typography>
                <Typography className={classes.greetingTitle}>
                    {strings.UD.GREETING_MORNING} <span>{firstName}.</span>
                </Typography>
                <Typography className={classes.greetingSubtitle}>
                    {strings.UD.GREETING_SUBTITLE}{' '}
                    <strong>{strings.UD.GREETING_APPS_WAITING.replace('{pending}', pending.length)}</strong>{' '}
                    {strings.UD.GREETING_APPS_WAITING_SUFFIX}{' '}
                    <strong>{strings.UD.GREETING_CHECKS.replace('{checks}', stats.checksPending || 0)}</strong>{' '}
                    {strings.UD.GREETING_CHECKS_SUFFIX}
                </Typography>
            </Box>
            <Box className={classes.timeTabs}>
                {['today', 'week', 'month'].map((t) => (
                    <button
                        key={t}
                        className={`${classes.timeTab} ${range === t ? classes.timeTabActive : ''}`}
                        onClick={() => setRange(t)}
                    >
                        {t === 'today' ? strings.UD.TIME_TAB_TODAY : t === 'week' ? strings.UD.TIME_TAB_WEEK : strings.UD.TIME_TAB_MONTH}
                    </button>
                ))}
            </Box>
        </Box>
    )
}

export default UDHeader
